import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'redux-router';
import { loadEvents, setHeader, incrementEventsFilter, decrementEventsFilter, rawSetEventsFilter, setEventsSearch } from 'actions';
import shallowEqual from 'react-pure-render/shallowEqual';
import Calendar from 'lib/Calendar';
import moment from 'moment';
import SwipeableViews from 'react-swipeable-views';
import has from 'lodash/has';
import auth from 'lib/Auth';

import EventList from 'components/calendar/EventList';
import EventListItem from 'components/calendar/EventListItem';
import CalendarFilter from 'components/calendar/CalendarFilter';
import Icon from 'components/common/Icon';
import Loading from 'components/common/Loading';
import DayPicker from 'components/calendar/DayPicker';

class CalendarViewPage extends Component {
  constructor(props) {
    super(props);

    this.renderEventListItem = this.renderEventListItem.bind(this);
    this.handleLoadNext = this.handleLoadNext.bind(this);
    this.handleLoadPrev = this.handleLoadPrev.bind(this);
    this.handleUpdateFilter = this.handleUpdateFilter.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);

    this.viewFilterCache = props.filter || {};

    this.state = {
      showSearch: !!props.eventsSearch || false,
      selectedIndex: 1,
    };
  }

  componentWillMount() {
    this.loadData(this.props);
    this.updateHeader(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.view !== this.props.view) {
      this.viewFilterCache = nextProps.filter;
      this.loadData(nextProps);
    }
    if (!shallowEqual(nextProps.filter, this.props.filter)) {
      this.updateHeader(nextProps);
    }
    if (!shallowEqual(nextProps.metadata, this.props.metadata)) {
      this.viewFilterCache = nextProps.filter;
      this.updateHeader(nextProps);
    }
  }

  loadData(props) {
    const { view, filter, eventsSearch } = props;

    this.viewFilterCache = Object.assign(Calendar.filterFromMoment(moment()), filter);
    this.props.loadEvents(view, Object.assign({}, filter), eventsSearch);
  }

  toggleSearch() {
    this.setState({ showSearch: !this.state.showSearch }, () =>
      this.updateHeader(this.props)
    );
  }

  updateHeader(props) {
    const rightNow = Calendar.momentFromFilter(this.viewFilterCache);

    let label = rightNow.format('MMMM YYYY');
    if (props.view === 'day') {
      label = rightNow.format('MMMM D, YYYY');
    } else if (props.view === 'week' && has(props, 'metadata.date_end') && has(props, 'metadata.date_start')) {
      const startMoment = moment(props.metadata.date_start);
      const endMoment = moment(props.metadata.date_end);
      if (startMoment.format('M') !== endMoment.format('M')) {
        label = `${startMoment.format('MMM')} - ${endMoment.format('MMM YYYY')}`;
      }
    } else if (props.view === 'year' && has(props, 'metadata.date_end') && has(props, 'metadata.date_start')) {
      const startMoment = moment(props.metadata.date_start);
      const endMoment = moment(props.metadata.date_end);
      if (startMoment.format('YYYY') !== endMoment.format('YYYY')) {
        label = `${startMoment.format('YYYY')} - ${endMoment.format('YYYY')}`;
      } else {
        label = `${startMoment.format('YYYY')}`;
      }
    }

    const headerTitle = (
      <span className="filter-bar">
        <Icon icon="arrow" size="medium" className="rotate-180" clickable onClick={() => this.handleLoadPrev()} />
        <span className="calendar-month-label">{label}</span>
        <Icon icon="arrow" size="medium" clickable onClick={() => this.handleLoadNext()} />
      </span>
      );

    const searchIcon = this.state.showSearch
      ? (<a className="clickable" onClick={() => this.toggleSearch()}>Cancel</a>)
      : (<Icon icon="search" size="medium" clickable onClick={() => this.toggleSearch()} />);

    let showBack = false;
    let backTitle = '';

    if(props.view == 'year') {
      showBack = true;
      backTitle = (prevRoute) => {
        const { pathname } = prevRoute;

        if (!pathname) {
          return '';
        }

        if (pathname.indexOf('page') !== -1) {

          let pageTitle = 'Report';

          if (has(window.CONFIG, 'enable_reports') && has(window.CONFIG, 'rename_schedules_to_reports')) {
            if (window.CONFIG.enable_reports === '1' && window.CONFIG.rename_schedules_to_reports === '2') {
              pageTitle = 'Page';
            } else if (window.CONFIG.enable_reports === '1' && window.CONFIG.rename_schedules_to_reports === '1') {
              pageTitle = 'Report';
            } else if (window.CONFIG.enable_reports === '1') {
              pageTitle = 'Schedule';
            }
          }

          if (pathname.indexOf('view') !== -1) {
            return pageTitle;
          } else {
            return pageTitle + 's';
          }
        }
        return '';
      };
    }

    this.props.setHeader(headerTitle, showBack, backTitle, searchIcon);
  }

  handleLoadNext() {
    const filter = Object.assign(
      {},
      this.props.filter,
      { month: this.viewFilterCache.month, year: this.viewFilterCache.year }
    );
    this.props.incrementEventsFilter(this.props.view, filter);
  }

  handleLoadPrev() {
    const filter = Object.assign(
      {},
      this.props.filter,
      { month: this.viewFilterCache.month, year: this.viewFilterCache.year }
    );
    this.props.decrementEventsFilter(this.props.view, filter);
  }

  handleUpdateFilter(filter, search) {
    const loadFilter = filter || this.props.filter;
    this.props.loadEvents(this.props.view, loadFilter, search);
  }

  renderEventListItem(event, drawDivider = false) {
    let timeFormat = 'start_time';
    if(this.props.view == 'year') timeFormat = 'start_date';
    return (
      <EventListItem
        drawDivider={drawDivider}
        timeFormat={timeFormat}
        event={event}
        key={`${event.date}_${event.id}`}
        onSelect={selectedEvent => this.props.push(`/calendar/details/${selectedEvent.id}`)}
      />
    );
  }

  render() {
    const { view, events, isLoading, filter, metadata } = this.props;
    const selectedDate = Calendar.momentFromFilter(this.props.filter);
    const daysWithEvents = {};
    let { subscribe_url } = metadata || {}; /* eslint camelcase: 0 */

    let viewEvents = events && events[view] ? events[view] : [];
    let content;
    let picker;

    let showToday = true;
    let showViewPicker = true;

    if (view == 'year') {
      showToday = false;
      showViewPicker = false;
    }

    if (view === 'week' || view === 'month') {
      viewEvents.forEach((event) => {
        daysWithEvents[event.labels.YYYMMDD] = true;
      });

      const matchDate = selectedDate.format('YYYY-MM-DD');
      viewEvents = viewEvents.filter(event => (event.labels.YYYMMDD === matchDate));
    }

    if (isLoading) {
      content = (
        <Loading withWrapper />
      );
    } else {
      let selectedEndDate;
      let selectedStartDate = selectedDate;
      if (view === 'list') {
        selectedStartDate = Calendar.momentFromFilter({ month: filter.month, year: filter.year, day: 1 });
        selectedEndDate = Calendar.momentFromFilter({ month: filter.month, year: filter.year, day: 1 }).endOf('month');
      }
      if(subscribe_url) subscribe_url = auth.getAuthURL(subscribe_url);
      let groupBy = 'day';
      if(this.props.view == 'year') groupBy = 'month';
      content = (
        <EventList
          selectedDate={selectedStartDate}
          selectedEndDate={selectedEndDate}
          groupBy={groupBy}
          events={viewEvents}
          key={view}
          isLoading={isLoading}
          renderItem={this.renderEventListItem}
          subscribeUrl={subscribe_url}
        />
      );
    }

    if (metadata && metadata.date_start && metadata.date_end && (view === 'month' || view === 'week')) {
      let prevStart = moment(metadata.date_start).subtract(1, view).format('YYYY-MM-DD');
      let prevEnd = moment(metadata.date_end).subtract(1, view).format('YYYY-MM-DD');
      let nextStart = moment(metadata.date_start).add(1, view).format('YYYY-MM-DD');
      let nextEnd = moment(metadata.date_end).add(1, view).format('YYYY-MM-DD');

      if (view === 'month') {
        // date_start is the 1st of the month meaning the previous month ends on the last day of the month
        if (moment(metadata.date_start).format('D') === '1') {
          prevStart = moment(metadata.date_start).subtract(35, 'days').format('YYYY-MM-DD');
        } else {
          prevStart = moment(metadata.date_start).subtract(28, 'days').format('YYYY-MM-DD');
        }

        // date_end is not a date in the next month meaning it must be the last day of the current active month
        if (parseInt(moment(metadata.date_end).format('D'), 10) > 10) {
          nextStart = moment(metadata.date_end).add(1, 'day').format('YYYY-MM-DD');
        } else {
          nextStart = moment(metadata.date_end).subtract(6, 'day').format('YYYY-MM-DD');
        }

        prevEnd = moment(prevStart).add(34, 'days').format('YYYY-MM-DD');
        nextEnd = moment(nextStart).add(34, 'days').format('YYYY-MM-DD');
      }

      picker = (
        <SwipeableViews
          key={`${view}${metadata.date_start}`}
          containerStyle={{ minHeight: 80 }}
          index={this.state.selectedIndex}
          onChangeIndex={(index, fromIndex) => {
            setTimeout(() => {
              this.setState({ selectedIndex: 1 });
              if (index > fromIndex) {
                this.handleLoadNext();
              } else {
                this.handleLoadPrev();
              }
            }, 300);
          }}
        >
          <DayPicker
            key={`${view}${metadata.date_start}-1`}
            startDate={prevStart}
            endDate={prevEnd}
            daysWithEvents={daysWithEvents}
            month={this.viewFilterCache.month}
            onSelect={(date) => {
              this.props.rawSetEventsFilter(date);
            }}
          />
          <DayPicker
            key={`${view}${metadata.date_start}-0`}
            startDate={metadata.date_start}
            endDate={metadata.date_end}
            selectedDate={selectedDate}
            daysWithEvents={daysWithEvents}
            month={this.viewFilterCache.month}
            onSelect={(date) => {
              this.props.rawSetEventsFilter(date);
            }}
          />
          <DayPicker
            key={`${view}${metadata.date_start}+1`}
            startDate={nextStart}
            endDate={nextEnd}
            daysWithEvents={daysWithEvents}
            month={this.viewFilterCache.month}
            onSelect={(date) => {
              this.props.rawSetEventsFilter(date);
            }}
          />
        </SwipeableViews>
      );
    }

    return (
      <div>
        <CalendarFilter
          view={view}
          filter={filter}
          setEventsSearch={this.props.setEventsSearch}
          updateFilter={this.handleUpdateFilter}
          showSearch={this.state.showSearch}
          showToday={showToday}
          showViewPicker={showViewPicker}
          search={this.props.eventsSearch}
        />
        {picker}
        {content}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { year, month, day } = state.router.params;
  let { view } = state.router.params;
  const { search } = state.router.location.query;
  const { calendar } = state;
  const { response, events, isLoading } = calendar || {};
  let { filter } = calendar || {};
  const { metadata } = response || {};

  if (!view) {
    view = 'week';
  }

  const routerFilter = { year, month, day };
  /* eslint array-callback-return: 0 */
  Object.getOwnPropertyNames(routerFilter)
    .map((key) => {
      if (!routerFilter[key]) {
        delete routerFilter[key];
      }
    });

  if (shallowEqual(filter, {})) {
    filter = routerFilter;
  }

  return {
    view,
    events,
    isLoading,
    filter,
    metadata,
    eventsSearch: calendar.search || search,
  };
}

export default connect(mapStateToProps, {
  loadEvents,
  incrementEventsFilter,
  decrementEventsFilter,
  rawSetEventsFilter,
  setHeader,
  setEventsSearch,
  push,
})(CalendarViewPage);



// WEBPACK FOOTER //
// ./src/app/containers/CalendarViewPage.js